import api from './api';

export const authService = {
  /**
   * Initialize Google Sign-In
   * Loads Google Identity Services library
   */
  initGoogleSignIn: () => {
    return new Promise((resolve, reject) => {
      if (window.google?.accounts) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Google Identity Services'));
      document.head.appendChild(script);
    });
  },

  /**
   * Sign in with Google using ID token
   * Sends ID token to backend /api/auth/google
   */
  signInWithGoogle: async (idToken) => {
    try {
      const response = await api.post('/auth/google', {
        idToken: idToken
      });
      
      // Log the response for debugging
      console.log('Backend response:', response.data);
      
      // Response format: { success: true, message: "...", data: { user: {...}, accessToken, refreshToken, ... } }
      if (response.data && response.data.success && response.data.data) {
        const data = response.data.data;
        
        // Validate response structure
        if (!data.user) {
          console.error('Missing user in response:', data);
          throw new Error('Invalid response: user data missing');
        }
        if (!data.accessToken) {
          console.error('Missing accessToken in response:', data);
          throw new Error('Invalid response: access token missing');
        }
        
        // Transform backend response to frontend expected format
        return {
          user: data.user,
          tokens: {
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
            tokenType: data.tokenType || 'Bearer',
            expiresIn: data.expiresIn
          }
        };
      }
      
      // Handle error response
      const errorMsg = response.data?.message || response.data?.error?.message || 'Authentication failed';
      throw new Error(errorMsg);
    } catch (error) {
      console.error('Sign in error:', error);
      console.error('Error response:', error.response?.data);
      throw error;
    }
  },

  /**
   * Logout user
   * Calls backend /api/auth/logout
   */
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
      // Clear local storage even if backend call fails
    }
  },
};

